export default [
    // {
    //     name: 'environmentMapTexture',
    //     type: 'cubeTexture',
    //     path:
    //     [
    //         'textures/environmentMap/px.jpg',
    //     ]
    // }
    {
        name: 'sunTexture',
        type: 'texture',
        path: 'sun.png',
    },
    {
        name: 'gridTexture',
        type: 'texture',
        path: 'grid.png',
    },
    {
        name: 'circleTexture',
        type: 'texture',
        path: 'circle.png',
    },
    {
        name: 'poppinsFont',
        type: 'font',
        path: 'fonts/Poppins_Regular.json',
    },
    {
        name: 'blueGridTexture',
        type: 'texture',
        path: 'low_gridblue.png',
    },

]